import api from '../services/api';
import { useEffect, useState } from 'react';

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        await api.get('/auth/verify');
        setIsAdmin(true);
      } catch (error) {
        setIsAdmin(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAdminStatus();
  }, []);

  return { isAdmin, isChecking };
}
